import template from 'product-meta.j2';

import { onStateChange } from '@product/js/utils/productComponentUtils';
import { launchAsyncWriteReview } from '@product/js/utils/asyncLaunchers';

import { mDom } from '@core/js/utils/renderUtils';
import { generate } from '@core/js/utils/componentUtils';

/**
 * Attach component events to DOM
 * @param {object} store The store
 */
function attachEvents(store) {
    $(document).on(this.scopedEvent('click'), this.scopedSelector('.js-product-reviews__count'), (e) => {
        e.preventDefault();

        launchAsyncWriteReview(store, e);
    });
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-pdp .dom-main-product .js-product-meta',
        attachEvents: attachEvents,
        onStateChange: onStateChange,
        watch: ['product.productMeta', 'product.productReviews'],
        template: template,
        name: 'productMetaComponent',
        forFamilyProduct: false,
        renderType: mDom
    };

    return generate(config, store, overrides);
}
